import environment from "../environment";
import { GET, POST } from "./http.service";

export const donateToProject = async (payload, monthly = false) => {
    const endpoint = monthly
        ? `${environment.DonationProject}/${payload.projectId}/monthly`
        : environment.DonationProject;
    const response = await POST(endpoint, payload, monthly);
    return response;
};

export const donateToCampaign = async (payload, monthly = false) => {
    const endpoint = monthly
        ? `${environment.DonationCampaign}/${payload.campaignId}/monthly`
        : environment.DonationCampaign;
    const response = await POST(endpoint, payload, monthly);
    return response;
};

export const donateToPlatform = async (payload, monthly = false) => {
    const endpoint = monthly
        ? environment.DonationPlatformMonthly
        : environment.DonationPlatform;
    const response = await POST(endpoint, payload);
    return response;
};

export const getDonationBySessionId = async (sessionId) => {
    const response = await GET(`${environment.SuccessPayment}${sessionId}`);
    return response;
};

export const getMyDonations = async ({
    source,
    pageIndex = 0,
    pageSize = 10,
    orderBy = "-Id",
    enablePagination = false,
} = {}) => {
    const params = new URLSearchParams({
        pageIndex: String(pageIndex),
        pageSize: String(pageSize),
        orderBy,
        enablePagination: String(enablePagination),
    });

    if (source) {
        params.append("source", source);
    }

    return GET(`${environment.MyDonations}?${params.toString()}`, true);
};

export const cancelMyDonation = async (id, cancelImmediately = true) => {
    const encodedId = encodeURIComponent(id);
    return POST(
        `${environment.MyDonations}/${encodedId}/cancel?cancelImmediately=${cancelImmediately}`,
        {},
        true,
    );
};
